import i18n from '@/locales/i18n'
import { DEVICE_ROUTES } from '@/router/routes'
import type { RouteType } from '@/types/Route'
import DeviceCreateViewVue from '@/views/DevicesView/DeviceCreateView.vue'
import DeviceDetailViewVue from '@/views/DevicesView/DeviceDetailView.vue'
import DevicesTableViewVue from '@/views/DevicesView/DevicesTableView.vue'
import { ref } from 'vue'

export enum EDeviceRoutesNames {
    DEVICE_TABLE = 'deviceTable',
    DEVICE_DETAIL = 'deviceDetail',
    DEVICE_CREATE = 'deviceCreate'
}
export const EDeviceRoutesNamesValues = [
    EDeviceRoutesNames.DEVICE_TABLE,
    EDeviceRoutesNames.DEVICE_DETAIL,
    EDeviceRoutesNames.DEVICE_CREATE
]

const routesDevices: RouteType[] = [
    {
        path: DEVICE_ROUTES.baseUrl,
        name: EDeviceRoutesNames.DEVICE_TABLE,
        component: DevicesTableViewVue,
        meta: {
            title: ref(i18n.global.t('menu.devices'))
        }
    },
    {
        path: DEVICE_ROUTES.detailUrl,
        name: EDeviceRoutesNames.DEVICE_DETAIL,
        component: DeviceDetailViewVue,
        meta: {
            title: ref(i18n.global.t('menu.devices'))
        }
    },
    {
        path: DEVICE_ROUTES.createUrl,
        name: EDeviceRoutesNames.DEVICE_CREATE,
        component: DeviceCreateViewVue,
        meta: {
            title: ref(i18n.global.t('menu.devices'))
        }
    }
]

export default routesDevices
